import UrlUtils from "./url-utils";

const padNum = (num: number) => num < 10 ? `0${num}` : num.toString();

const dateOptions = (options: any) => options as Intl.DateTimeFormatOptions;

const digitStyle = {
    numeric: "numeric",
    double: "2-digit"
}

class DateWrapper {
    date: Date;
    locale: string;

    constructor(date: Date | string | undefined) {
        this.date = date ? new Date(date) : new Date();
        this.locale = UrlUtils.getLanguageCode();
    }

    format(options: Intl.DateTimeFormatOptions) {
        return new Intl.DateTimeFormat(this.locale, options).format(this.date);
        //return this.date.toLocaleDateString(this.locale, options);
    }

    getTimeString(showSeconds = false) {
        const style = showSeconds ? "medium" : "short";
        return this.format({ timeStyle: style });
    }

    getDateString(hideCurrentYear = false) {
        const options = dateOptions({ year: digitStyle.numeric, month: "short", day: digitStyle.numeric });

        if (!hideCurrentYear) {
            return this.format(options);
        }

        const currentYear = new Date().getFullYear();

        if (this.date.getFullYear() === currentYear) {
            delete options.year;
        }

        return this.format(options);
    }

    get isTodaysDate() {
        const today = new Date();
        return this.dayFullMonthAndYear === dateWrapper(today).dayFullMonthAndYear;
    }

    get dayShortMonthAndFullYear() {
        const options = dateOptions({ year: digitStyle.numeric, month: "short", day: digitStyle.numeric });
        return this.format(options);
    }

    get dayFullMonthAndYear() {
        const options = dateOptions({ year: digitStyle.numeric, month: "long", day: digitStyle.numeric });
        return this.format(options);
    }

    get fullMonthAndYear() {
        const options = dateOptions({ year: digitStyle.numeric, month: "long" });
        return this.format(options);
    }

    get shortMonthAndYear() {
        const options = dateOptions({ year: digitStyle.numeric, month: "short" });
        return this.format(options);
    }

    get shortMonth() {
        const options = dateOptions({ month: "short" });;
        return this.format(options);
    }

    get shortDate() {
        // const options = dateOptions({ dateStyle: "short" });
        //return this.format(options).split("/").join("-");
        //en-ZA returns yyyy-MM-dd but want dd-MM-yyyy
        const options = dateOptions({
            year: "numeric",
            month: "numeric",
            day: "numeric",
        });

        return new Intl.DateTimeFormat("en-GB", options).format(this.date).split("/").join("-");
    }

    get time() {
        const options = dateOptions({ hour: digitStyle.numeric, minute: digitStyle.double, second: digitStyle.double, hour12: true });
        return this.format(options);
    }

    yearMonthDay(separator = "-") {
        return [
            this.date.getFullYear()
            , padNum(this.date.getMonth() + 1)
            , padNum(this.date.getDate())
        ].join(separator);
    }

    get timestamp() {
        const parts = [
            padNum(this.date.getHours()),
            padNum(this.date.getMinutes()),
            padNum(this.date.getSeconds()),
            padNum(this.date.getMilliseconds())
        ];

        return parts.join(":");
    }

    addDays(days: number) {
        days += this.date.getDate();
        this.date.setDate(days);
        return this;
    }

    addMonths(months: number) {
        months += this.date.getMonth();
        this.date.setMonth(months);
        return this;
    }

    firstOfMonth() {
        this.date.setDate(1);
        return this;
    }

    get isValid() {
        return this.date && this.date.toString() !== "Invalid Date";
    }
}

export const dateWrapper = (date: Date | string | undefined = undefined) => new DateWrapper(date);

export const isValidDate = (value: string) => {
    const date = new Date(value);
    return date.toString() !== "Invalid Date";
}

export default dateWrapper;
